import { connect } from 'react-redux';
import { RootState } from '../../store';
import { ILocalization } from '../../localization/definitions/types';
import { cognitoSignOut } from '../../services/authentication';

interface IProps {
    localization: ILocalization;
}

const ProfileIconDropdownMenu = ({ localization }: IProps) => {
    const profileIconDropdownMenuLocalization =
        localization.localizationStrings.susy.navbar
            .profileIconDropdownMenuLocalization;

    const handleLogout = async () => {
        await cognitoSignOut();
        window.location.href = '/signIn';
    };

    return (
        <span className='dropdown-item' onClick={handleLogout}>
            {profileIconDropdownMenuLocalization.logoutMenuItem}
        </span>
    );
};

const mapStateToProps = (state: RootState) => ({
    localization: state.localization,
});

export default connect(mapStateToProps)(ProfileIconDropdownMenu);
